import {Action} from '@ngrx/store';
import {DressCodePicture} from '../../../models/dress-code-picture';
import {BijbEvent} from '../../../models/bijb-event';

export class DeleteDressCodePictureAction implements Action {
  public static readonly type = 'DeleteDressCodePictureAction';

  constructor(public bijbEvent: BijbEvent, public dressCodePicture: DressCodePicture) {
  }

  public type = DeleteDressCodePictureAction.type;
}
